export interface GameDay {
  date: string;
  opponent: string;
  time: string;
  dayOfWeek: string;
  ticketSaleDate?: string;
  specialEvent?: string;
  specialEventColor?: string;
  matchLabel?: string;
  isHoliday?: boolean;
}

export const specialEventStyles: Record<string, { label: string; bg: string; text: string; icon: string; description: string }> = {
  "花火ナイト": { label: "花火ナイト", bg: "bg-red-100", text: "text-red-700", icon: "ri-magic-line", description: "試合終了後、エスコンフィールドの夜空を彩る迫力満点の花火大会を開催！夏の夜を華やかに締めくくる恒例イベントです。約3,000発の花火が打ち上がります。" },
  "ユニフォームデー": { label: "ユニフォームデー", bg: "bg-blue-100", text: "text-blue-700", icon: "ri-shirt-line", description: "ご来場の先着20,000名様に、選手着用モデルのレプリカユニフォームをプレゼント！この日だけの限定デザインです。" },
  "キッズデー": { label: "キッズデー", bg: "bg-yellow-100", text: "text-yellow-700", icon: "ri-emotion-happy-line", description: "小学生以下のお子様を対象に、選手とのハイタッチ会やグラウンド体験など親子で楽しめるイベントが盛りだくさん！お子様連れに大人気の企画です。" },
  "北海道スペシャル": { label: "北海道SP", bg: "bg-emerald-100", text: "text-emerald-700", icon: "ri-map-pin-line", description: "北海道の食と文化を満喫できるスペシャルデー！道内各地のご当地グルメが出店し、北海道ならではのエンターテイメントが試合を盛り上げます。" },
  "ファン感謝デー": { label: "ファン感謝デー", bg: "bg-pink-100", text: "text-pink-700", icon: "ri-heart-line", description: "日頃のご声援に感謝を込めて、選手によるスペシャルトークショーや抽選会などファン参加型イベントを多数開催！選手との距離がぐっと近づく特別な一日です。" },
  "レジェンドOB登場": { label: "OBレジェンド", bg: "bg-amber-100", text: "text-amber-700", icon: "ri-star-line", description: "ファイターズの歴史を彩ったレジェンドOBが始球式とトークショーに登場！往年の名選手を間近で見られる貴重なチャンスです。" },
  "WE LOVE HOKKAIDO": { label: "WE LOVE HOKKAIDO", bg: "bg-emerald-100", text: "text-emerald-700", icon: "ri-heart-pulse-line", description: "北海道を愛する気持ちを込めたスペシャルユニフォームを来場者全員にプレゼント！WE LOVE HOKKAIDOシリーズ限定の特別デザインです。" },
  "シャウ祭り": { label: "シャウ祭り", bg: "bg-orange-100", text: "text-orange-700", icon: "ri-restaurant-line", description: "シャウエッセンとのコラボ企画！来場者限定ユニフォーム配布やシャウダンスなど、夏を盛り上げる楽しいイベントが満載です。" },
  "紅白戦": { label: "紅白戦", bg: "bg-rose-100", text: "text-rose-700", icon: "ri-team-line", description: "ファイターズ選手が紅組・白組に分かれて行う実戦形式の練習試合。来季に向けた新戦力や若手選手のアピールの場として、ファンも無料で観戦できる貴重な機会です。" },
  "クライマックスシリーズ": { label: "CS(仮)", bg: "bg-amber-100", text: "text-amber-700", icon: "ri-trophy-line", description: "クライマックスシリーズ（CS）は、レギュラーシーズンの順位を基に日本シリーズ進出をかけて戦うポストシーズン。1戦ごとに歓声が響く、シーズン最高潮の熱戦をお見逃しなく！（日程は仮のため変更となる場合があります）" },
  "ファン感謝祭": { label: "ファン感謝祭", bg: "bg-pink-100", text: "text-pink-700", icon: "ri-heart-3-line", description: "1年間の応援に感謝を込めて開催されるファン感謝祭！選手によるトークショーやサイン会、抽選会などファン参加型のイベントが満載で、選手と間近でふれあえる特別な一日です。" },
};

export const fightersSchedule2026: GameDay[] = [
  // ===== 3月 =====
  { date: "2026-03-31", opponent: "千葉ロッテ", time: "18:00", dayOfWeek: "火", ticketSaleDate: "2026-03-01" },

  // ===== 4月 =====
  { date: "2026-04-01", opponent: "千葉ロッテ", time: "18:00", dayOfWeek: "水", ticketSaleDate: "2026-03-01" },
  { date: "2026-04-02", opponent: "千葉ロッテ", time: "18:00", dayOfWeek: "木", ticketSaleDate: "2026-03-01" },
  { date: "2026-04-03", opponent: "オリックス", time: "18:00", dayOfWeek: "金", ticketSaleDate: "2026-03-03" },
  { date: "2026-04-04", opponent: "オリックス", time: "14:00", dayOfWeek: "土", ticketSaleDate: "2026-03-03" },
  { date: "2026-04-05", opponent: "オリックス", time: "13:00", dayOfWeek: "日", ticketSaleDate: "2026-03-03" },
  { date: "2026-04-11", opponent: "ソフトバンク", time: "14:00", dayOfWeek: "土", ticketSaleDate: "2026-03-11", specialEvent: "ユニフォームデー" },
  { date: "2026-04-12", opponent: "ソフトバンク", time: "13:00", dayOfWeek: "日", ticketSaleDate: "2026-03-11" },
  { date: "2026-04-13", opponent: "ソフトバンク", time: "18:00", dayOfWeek: "月", ticketSaleDate: "2026-03-11" },
  { date: "2026-04-21", opponent: "楽天", time: "18:00", dayOfWeek: "火", ticketSaleDate: "2026-03-21" },
  { date: "2026-04-22", opponent: "楽天", time: "18:00", dayOfWeek: "水", ticketSaleDate: "2026-03-21" },
  { date: "2026-04-23", opponent: "楽天", time: "18:00", dayOfWeek: "木", ticketSaleDate: "2026-03-21" },
  { date: "2026-04-28", opponent: "西武", time: "18:00", dayOfWeek: "火", ticketSaleDate: "2026-03-28" },
  { date: "2026-04-29", opponent: "西武", time: "14:00", dayOfWeek: "水", ticketSaleDate: "2026-03-28" },
  { date: "2026-04-30", opponent: "西武", time: "18:00", dayOfWeek: "木", ticketSaleDate: "2026-03-28" },

  // ===== 5月 =====
  { date: "2026-05-01", opponent: "オリックス", time: "18:00", dayOfWeek: "金", ticketSaleDate: "2026-04-01" },
  { date: "2026-05-02", opponent: "オリックス", time: "14:00", dayOfWeek: "土", ticketSaleDate: "2026-04-01", specialEvent: "キッズデー" },
  { date: "2026-05-03", opponent: "オリックス", time: "13:00", dayOfWeek: "日", ticketSaleDate: "2026-04-01" },
  { date: "2026-05-12", opponent: "ソフトバンク", time: "18:00", dayOfWeek: "火", ticketSaleDate: "2026-04-12" },
  { date: "2026-05-13", opponent: "ソフトバンク", time: "18:00", dayOfWeek: "水", ticketSaleDate: "2026-04-12" },
  { date: "2026-05-14", opponent: "ソフトバンク", time: "18:00", dayOfWeek: "木", ticketSaleDate: "2026-04-12" },
  { date: "2026-05-22", opponent: "楽天", time: "18:00", dayOfWeek: "金", ticketSaleDate: "2026-04-22" },
  { date: "2026-05-23", opponent: "楽天", time: "14:00", dayOfWeek: "土", ticketSaleDate: "2026-04-22" },
  { date: "2026-05-24", opponent: "楽天", time: "13:00", dayOfWeek: "日", ticketSaleDate: "2026-04-22" },

  // ===== 6月 =====
  { date: "2026-06-05", opponent: "巨人", time: "18:00", dayOfWeek: "金", ticketSaleDate: "2026-05-05" },
  { date: "2026-06-06", opponent: "巨人", time: "14:00", dayOfWeek: "土", ticketSaleDate: "2026-05-05", specialEvent: "レジェンドOB登場" },
  { date: "2026-06-07", opponent: "巨人", time: "13:00", dayOfWeek: "日", ticketSaleDate: "2026-05-05" },
  { date: "2026-06-12", opponent: "ヤクルト", time: "18:00", dayOfWeek: "金", ticketSaleDate: "2026-05-12" },
  { date: "2026-06-13", opponent: "ヤクルト", time: "14:00", dayOfWeek: "土", ticketSaleDate: "2026-05-12" },
  { date: "2026-06-14", opponent: "ヤクルト", time: "13:00", dayOfWeek: "日", ticketSaleDate: "2026-05-12" },
  { date: "2026-06-30", opponent: "オリックス", time: "18:00", dayOfWeek: "火", ticketSaleDate: "2026-05-30", specialEvent: "WE LOVE HOKKAIDO" },

  // ===== 7月 =====
  { date: "2026-07-10", opponent: "西武", time: "18:00", dayOfWeek: "金", ticketSaleDate: "2026-06-10", specialEvent: "WE LOVE HOKKAIDO" },
  { date: "2026-07-11", opponent: "西武", time: "14:00", dayOfWeek: "土", ticketSaleDate: "2026-06-10", specialEvent: "花火ナイト" },
  { date: "2026-07-12", opponent: "西武", time: "13:00", dayOfWeek: "日", ticketSaleDate: "2026-06-10" },
  { date: "2026-07-13", opponent: "ソフトバンク", time: "13:00", dayOfWeek: "月", ticketSaleDate: "2026-06-13" },
  { date: "2026-07-14", opponent: "ソフトバンク", time: "13:00", dayOfWeek: "火", ticketSaleDate: "2026-06-13" },
  { date: "2026-07-15", opponent: "ソフトバンク", time: "13:00", dayOfWeek: "水", ticketSaleDate: "2026-06-13" },
  { date: "2026-07-25", opponent: "楽天", time: "14:00", dayOfWeek: "土", ticketSaleDate: "2026-06-25" },
  { date: "2026-07-26", opponent: "楽天", time: "13:00", dayOfWeek: "日", ticketSaleDate: "2026-06-25", specialEvent: "北海道スペシャル" },
  { date: "2026-07-31", opponent: "千葉ロッテ", time: "18:00", dayOfWeek: "金", ticketSaleDate: "2026-07-01" },

  // ===== 8月 =====
  { date: "2026-08-01", opponent: "千葉ロッテ", time: "14:00", dayOfWeek: "土", ticketSaleDate: "2026-07-01" },
  { date: "2026-08-02", opponent: "千葉ロッテ", time: "13:00", dayOfWeek: "日", ticketSaleDate: "2026-07-01" },
  { date: "2026-08-07", opponent: "楽天", time: "18:00", dayOfWeek: "金", ticketSaleDate: "2026-07-07" },
  { date: "2026-08-08", opponent: "楽天", time: "15:00", dayOfWeek: "土", ticketSaleDate: "2026-07-07", specialEvent: "花火ナイト" },
  { date: "2026-08-09", opponent: "楽天", time: "14:00", dayOfWeek: "日", ticketSaleDate: "2026-07-07", specialEvent: "シャウ祭り" },
  { date: "2026-08-11", opponent: "西武", time: "14:00", dayOfWeek: "火", ticketSaleDate: "2026-07-11" },
  { date: "2026-08-12", opponent: "西武", time: "18:00", dayOfWeek: "水", ticketSaleDate: "2026-07-11" },
  { date: "2026-08-13", opponent: "西武", time: "18:00", dayOfWeek: "木", ticketSaleDate: "2026-07-11" },
  { date: "2026-08-18", opponent: "ソフトバンク", time: "14:00", dayOfWeek: "火", ticketSaleDate: "2026-07-18" },
  { date: "2026-08-19", opponent: "ソフトバンク", time: "14:00", dayOfWeek: "水", ticketSaleDate: "2026-07-18", specialEvent: "北海道スペシャル" },
  { date: "2026-08-20", opponent: "ソフトバンク", time: "14:00", dayOfWeek: "木", ticketSaleDate: "2026-07-18" },
  { date: "2026-08-28", opponent: "千葉ロッテ", time: "18:00", dayOfWeek: "金", ticketSaleDate: "2026-07-28" },
  { date: "2026-08-29", opponent: "千葉ロッテ", time: "14:00", dayOfWeek: "土", ticketSaleDate: "2026-07-28" },
  { date: "2026-08-30", opponent: "千葉ロッテ", time: "13:00", dayOfWeek: "日", ticketSaleDate: "2026-07-28" },

  // ===== 9月 =====
  { date: "2026-09-15", opponent: "千葉ロッテ", time: "18:00", dayOfWeek: "火", ticketSaleDate: "2026-08-15" },
  { date: "2026-09-17", opponent: "西武", time: "18:00", dayOfWeek: "木", ticketSaleDate: "2026-08-15" },
  { date: "2026-09-19", opponent: "オリックス", time: "14:00", dayOfWeek: "土", ticketSaleDate: "2026-08-19" },
  { date: "2026-09-20", opponent: "オリックス", time: "14:00", dayOfWeek: "日", ticketSaleDate: "2026-08-19" },
  { date: "2026-09-21", opponent: "オリックス", time: "14:00", dayOfWeek: "月", ticketSaleDate: "2026-08-19" },
  { date: "2026-09-22", opponent: "楽天", time: "18:00", dayOfWeek: "火", ticketSaleDate: "2026-08-22" },
  { date: "2026-09-23", opponent: "楽天", time: "18:00", dayOfWeek: "水", ticketSaleDate: "2026-08-22" },
  { date: "2026-09-24", opponent: "楽天", time: "18:00", dayOfWeek: "木", ticketSaleDate: "2026-08-22" },

  // ===== 10月 =====
  { date: "2026-10-04", opponent: "紅白戦", matchLabel: "紅白戦", time: "13:00", dayOfWeek: "日", specialEvent: "紅白戦" },
  { date: "2026-10-07", opponent: "紅白戦", matchLabel: "紅白戦", time: "13:00", dayOfWeek: "水", specialEvent: "紅白戦" },
  { date: "2026-10-10", opponent: "クライマックスシリーズ(仮)", matchLabel: "クライマックスシリーズ(仮)", time: "14:00", dayOfWeek: "土", specialEvent: "クライマックスシリーズ" },
  { date: "2026-10-11", opponent: "クライマックスシリーズ(仮)", matchLabel: "クライマックスシリーズ(仮)", time: "14:00", dayOfWeek: "日", specialEvent: "クライマックスシリーズ" },
  { date: "2026-10-12", opponent: "クライマックスシリーズ(仮)", matchLabel: "クライマックスシリーズ(仮)", time: "14:00", dayOfWeek: "月", specialEvent: "クライマックスシリーズ", isHoliday: true },

  // ===== 11月 =====
  { date: "2026-11-21", opponent: "ファン感謝祭", matchLabel: "ファン感謝祭", time: "13:00", dayOfWeek: "土", specialEvent: "ファン感謝祭" },
  { date: "2026-11-22", opponent: "レジェンド戦", matchLabel: "レジェンド", time: "13:00", dayOfWeek: "日", ticketSaleDate: "2026-10-22", specialEvent: "レジェンドOB登場" },
];

export const opponentColors: Record<string, string> = {
  "レジェンド戦": "bg-amber-600",
  "紅白戦": "bg-rose-600",
  "クライマックスシリーズ(仮)": "bg-amber-500",
  "ファン感謝祭": "bg-pink-500",
  "千葉ロッテ": "bg-foreground-900",
  "オリックス": "bg-blue-600",
  "西武": "bg-blue-500",
  "ソフトバンク": "bg-yellow-500",
  "楽天": "bg-red-600",
  "巨人": "bg-orange-600",
  "ヤクルト": "bg-emerald-700",
  "広島": "bg-red-500",
};

export const opponentShortNames: Record<string, string> = {
  "レジェンド戦": "レジェンド",
  "紅白戦": "紅白戦",
  "クライマックスシリーズ(仮)": "CS(仮)",
  "ファン感謝祭": "感謝祭",
  "千葉ロッテ": "ロッテ",
  "オリックス": "オリックス",
  "西武": "西武",
  "ソフトバンク": "ソフトバンク",
  "楽天": "楽天",
  "巨人": "巨人",
  "ヤクルト": "ヤクルト",
  "広島": "広島",
};

export const monthLabels = [
  "",
  "1月", "2月", "3月", "4月", "5月", "6月",
  "7月", "8月", "9月", "10月", "11月", "12月",
];